/**
 * Phone number validation utilities using country-specific format strings.
 * Format strings use 'X' as a digit placeholder (e.g., '(XX) XXXXX-XXXX').
 */

/**
 * Converts a phone format mask string to a RegExp.
 * Escapes regex special characters: (, ), .
 * Replaces 'X' with '\d'.
 *
 * Examples:
 *   '(XX) XXXXX-XXXX' → /^\(\d{2}\) \d{5}-\d{4}$/
 *   'X XXXX XXXX'     → /^\d \d{4} \d{4}$/
 * @param {string} format - Phone format string from countryConfig
 * @returns {RegExp|null}
 */
export const phoneFormatToRegex = (format) => {
  if (!format) return null;
  const regexStr = format
    .replace(/\(/g, '\\(')
    .replace(/\)/g, '\\)')
    .replace(/\./g, '\\.')
    .replace(/X/g, '\\d');
  return new RegExp(`^${regexStr}$`);
};

/**
 * Validates a phone number against the given format string.
 * Accepts either exact formatted input (e.g. '(11) 98765-4321') or digits-only
 * input with the correct digit count (e.g. '11987654321').
 * Returns true when value is empty (phone is optional) or when format is absent.
 * @param {string} value - Phone number entered by user
 * @param {string} phoneFormat - Format string from countryConfig (e.g., '(XX) XXXXX-XXXX')
 * @returns {boolean}
 */
export const validatePhone = (value, phoneFormat) => {
  if (!value || !phoneFormat) return true;
  const inputDigits = value.replace(/\D/g, '');
  const expectedDigits = phoneFormat.replace(/[^X]/g, '').length;
  return inputDigits.length === expectedDigits;
};
